<div class="gw-bg-background-elevation-2 gw-border-base gw-overflow-hidden">
  <tui-tabs
    [(activeItemIndex)]="activeItemIndex"
    class="gw-border-b gw-border-border-normal gw-px-small gw-pt-small"
  >
    <button tuiTab type="button">
      <gatewee-icon
        [icon]="'@tui.arrow-left-right'"
        class="gw-mr-small"
      ></gatewee-icon>

      {{ 'common.transactionsFeesTabs.tabs.transactions' | translate }}
    </button>
    <button tuiTab type="button" [disabled]="feeLineCount === 0">
      <gatewee-icon
        [icon]="'@tui.banknote-arrow-up'"
        class="gw-mr-small"
      ></gatewee-icon>

      {{ 'common.transactionsFeesTabs.tabs.fees' | translate }}
      <span
        *ngIf="feeLineCount > 0"
        class="gw-ml-small gw-badge gw-bg-background-elevation-2"
      >
        {{ feeLineCount }}
      </span>
    </button>
  </tui-tabs>

  <div class="gw-p-medium">
    <div *ngIf="activeItemIndex === 0">
      <ng-container *ngIf="transactionsList.length; else noTxTab">
        <div class="gw-overflow-x-auto">
          <table class="gw-w-full gw-bg-background-elevation-2">
            <thead>
              <tr class="gw-border-b gw-border-border-normal">
                <th
                  class="gw-w-14 gw-px-medium gw-py-small gw-text-left gw-text-xs gw-font-semibold gw-text-text-secondary"
                >
                  {{ 'common.transactionsFeesTabs.table.index' | translate }}
                </th>
                <th
                  class="gw-px-medium gw-py-small gw-text-left gw-text-xs gw-font-semibold gw-text-text-secondary"
                >
                  {{ 'common.transactionsFeesTabs.table.amount' | translate }}
                </th>
                <th
                  class="gw-px-medium gw-py-small gw-text-left gw-text-xs gw-font-semibold gw-text-text-secondary"
                >
                  {{
                    'common.transactionsFeesTabs.table.statusDates' | translate
                  }}
                </th>
                <th
                  class="gw-px-medium gw-py-small gw-text-left gw-text-xs gw-font-semibold gw-text-text-secondary"
                >
                  {{
                    'common.transactionsFeesTabs.table.recipient' | translate
                  }}
                </th>
                <th
                  class="gw-px-medium gw-py-small gw-text-center gw-text-xs gw-font-semibold gw-text-text-secondary"
                >
                  {{ 'common.transactionsFeesTabs.table.type' | translate }}
                </th>
              </tr>
            </thead>
            <tbody class="gw-text-base">
              <tr
                *ngFor="let tx of transactionsList; let i = index"
                class="gw-border-b gw-border-border-normal hover:gw-bg-background-elevation-2"
              >
                <td class="gw-py-medium gw-px-medium">{{ i + 1 }}</td>
                <td class="gw-py-medium gw-px-medium">
                  <span class="gw-font-medium gw-text-text-positive">
                    {{ tx.amount | currency : currencyCode }}
                  </span>
                  <div class="gw-text-xs gw-text-text-secondary">
                    {{ 'common.transactionsFeesTabs.tx.id' | translate }}
                    {{ tx.id }}
                  </div>
                </td>
                <td class="gw-py-medium gw-px-medium">
                  <span
                    class="gw-badge gw-text-xs"
                    [ngClass]="getStatusBadgeClass(tx.status)"
                  >
                    {{ tx.status | transactionStatus }}
                  </span>
                  <div
                    class="gw-text-xs gw-text-text-secondary gw-mt-medium"
                    *ngIf="tx.createdAt"
                  >
                    {{ 'common.transactionsFeesTabs.tx.created' | translate }}
                    {{ tx.createdAt | date : 'dd/MM/yyyy HH:mm' }}
                  </div>
                  <div
                    *ngIf="tx.conciliatedAt"
                    class="gw-text-xs gw-text-text-secondary"
                  >
                    {{
                      'common.transactionsFeesTabs.tx.conciliated' | translate
                    }}
                    {{ tx.conciliatedAt | date : 'dd/MM/yyyy HH:mm' }}
                  </div>
                  <div
                    *ngIf="tx.updatedAt"
                    class="gw-text-xs gw-text-text-secondary"
                  >
                    {{ 'common.transactionsFeesTabs.tx.updated' | translate }}
                    {{ tx.updatedAt | date : 'dd/MM/yyyy HH:mm' }}
                  </div>
                </td>
                <td class="gw-py-medium gw-px-medium">
                  <ng-container *ngIf="tx.recipient; else noRecipient">
                    <span class="gw-font-medium">{{ tx.recipient.name }}</span>
                    <div class="gw-text-xs gw-text-text-secondary">
                      {{ tx.recipient.document | document : true }}
                    </div>
                  </ng-container>
                  <ng-template #noRecipient>
                    <span class="gw-text-text-secondary">—</span>
                  </ng-template>
                </td>
                <td class="gw-px-medium gw-py-medium gw-text-center">
                  <gatewee-icon
                    *ngIf="tx.type === 'income'"
                    [icon]="'@tui.arrow-down-circle'"
                    class="gw-inline-flex gw-text-status-positive gw-text-xl"
                  ></gatewee-icon>
                  <gatewee-icon
                    *ngIf="tx.type !== 'income'"
                    [icon]="'@tui.arrow-up-circle'"
                    class="gw-inline-flex gw-text-status-negative gw-text-xl"
                  ></gatewee-icon>
                  <span class="gw-mt-2x-small gw-block gw-text-xs">{{
                    tx.type | transactionType
                  }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
      <ng-template #noTxTab>
        <div class="gw-text-center gw-py-2x-large">
          <gatewee-icon
            [icon]="'@tui.inbox'"
            class="gw-text-4xl gw-text-text-secondary gw-mb-medium gw-inline-flex"
          ></gatewee-icon>
          <p class="gw-text-text-secondary">
            {{
              'common.transactionsFeesTabs.empty.transactionsTitle' | translate
            }}
          </p>
          <p class="gw-text-sm gw-text-text-secondary">
            {{
              'common.transactionsFeesTabs.empty.transactionsHint' | translate
            }}
          </p>
        </div>
      </ng-template>
    </div>

    <div *ngIf="activeItemIndex === 1">
      <ng-container *ngIf="feeLineCount > 0; else noFeesTab">
        <gatewee-fee-snapshot-table
          [feeSnapshot]="feeSnapshot"
          [currencyCode]="currencyCode"
        ></gatewee-fee-snapshot-table>
      </ng-container>
      <ng-template #noFeesTab>
        <div class="gw-text-center gw-py-2x-large">
          <gatewee-icon
            [icon]="'@tui.percent'"
            class="gw-text-4xl gw-text-text-secondary gw-mb-medium gw-inline-flex"
          ></gatewee-icon>
          <p class="gw-text-text-secondary">
            {{ 'common.transactionsFeesTabs.empty.feesTitle' | translate }}
          </p>
          <p class="gw-text-sm gw-text-text-secondary">
            {{ 'common.transactionsFeesTabs.empty.feesHint' | translate }}
          </p>
        </div>
      </ng-template>
    </div>
  </div>
</div>
